package pt.at.oss.kotlin.manual.storage.importform

import kotlinx.serialization.Serializable
import pt.at.oss.kotlin.manual.storage.common.Address
import pt.at.oss.kotlin.manual.storage.common.VatId
import pt.at.oss.kotlin.manual.storage.common.bankaccountinfo.BankAccountInfo
import pt.at.oss.kotlin.manual.storage.common.contactinfo.ContactInfo
import pt.at.oss.kotlin.manual.storage.common.contactname.ContactName
import pt.at.oss.kotlin.manual.storage.common.currvatid.CurrVatId
import pt.at.oss.kotlin.manual.storage.common.fixedestablishments.FixedEstablishmentsEntry
import pt.at.oss.kotlin.manual.storage.common.relevantdates.RelevantDates
import pt.at.oss.kotlin.manual.storage.common.tradingnames.TradingNamesEntry
import pt.at.oss.kotlin.manual.storage.common.websites.WebsitesEntry
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * NonUnionForm Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class ImportForm(
    var intermediaryVat: String = "",
    var currVatId: CurrVatId? = CurrVatId(),
    var identificationOfBusiness: VatId = VatId(),
    var bankAccountInfo: BankAccountInfo? = null,
    var fixedEstablishments: MutableList<FixedEstablishmentsEntry> = mutableListOf(),
    var companyName: String = "",
    var tradingNames: MutableList<TradingNamesEntry> = mutableListOf(),
    var countryOfBusiness: String? = null,
    var cobRegion: String? = null,
    var address: Address = Address(),
    var websites: MutableList<WebsitesEntry> = mutableListOf(),
    var contactName: ContactName = ContactName(),
    var contactInfo: ContactInfo = ContactInfo(),
    var prevOrCurrOssVatId: MutableList<VatId> = mutableListOf(),
    var relevantDates: RelevantDates? = RelevantDates()
) : BaseRecord()
